var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWikiNewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    strokeWidth: 0.8,
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ffff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comment"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 60,
    width: 60
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.43,24.47H28.8a1,1,0,0,0,0-2H15.43a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.43,31.26H28.8a1,1,0,0,0,0-2H15.43a1,1,0,1,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.37,20.94A5.85,5.85,0,0,0,55,13.47a4.61,4.61,0,0,0-8.36-3.76l-.69,1.18a1,1,0,0,0-1.22.42L42.93,14.4H8.21a2.71,2.71,0,0,0-2.7,2.7V43.42a2.71,2.71,0,0,0,2.7,2.7H22v4.3a1,1,0,0,0,.5.87,1,1,0,0,0,.5.13,1,1,0,0,0,.49-.13l9.18-5.17H47.26a2.7,2.7,0,0,0,2.7-2.7V24.05l4.21-7.29a1,1,0,0,0-.25-1.26l.1-.19a3.83,3.83,0,0,1,.62,4.63l-3.11,5.38a3.34,3.34,0,0,0,1.22,4.56,1,1,0,0,0,1-1.73,1.34,1.34,0,0,1-.49-1.83ZM48,43.42a.7.7,0,0,1-.7.7H32.44a1,1,0,0,0-.49.13L24,48.71V45.12a1,1,0,0,0-1-1H8.21a.71.71,0,0,1-.7-.7V17.1a.71.71,0,0,1,.7-.7H41.77l-8,13.79a1.07,1.07,0,0,0-.11.72l1.19,5.14H15.43a1,1,0,0,0,0,2H36.12l.13,0a1.23,1.23,0,0,0,.19,0l6.25-1.91a1,1,0,0,0,.57-.45L48,27.51ZM36.88,35.78l-.71-3.08,3.74,2.16Zm5.15-2-6-3.46L46,13.17l6,3.46ZM52.87,13.32l-.67,1.15-4.52-2.61.67-1.15a2.61,2.61,0,1,1,4.52,2.61Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiNewIcon);
export default __webpack_public_path__ + "static/media/wikiNewIcon.ef318736fb248083ef8ff3032efa78e4.svg";
export { ForwardRef as ReactComponent };